module.exports = __webpack_public_path__ + "img/list20231114004.8ba569ae.png";